import React from 'react';
import Collapse from 'react-bootstrap/lib/Collapse';
import { FormattedMessage } from 'react-intl';

class Disclaimer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  render() {
    const { open } = this.state;
    return (
      <div className="container-fluid disclaimer notranslate">
        <div className="container">
          <div className="text-muted">
            <h5 style={{ cursor: 'pointer' }} onClick={() => this.setState({ open: !open })}>
              Disclaimer &nbsp;
              <i className={`glyphicon glyphicon-chevron-${open ? 'up' : 'down'}`}/>
            </h5>
            <Collapse in={open}>
              <div>
                <p>
                  <FormattedMessage id="disclaimer.part.one"/>
                </p>
                <p>
                  <FormattedMessage id="disclaimer.part.two"/>
                </p>
                <p>
                  <FormattedMessage id="disclaimer.part.three"/>
                </p>
                <p>
                  <FormattedMessage id="disclaimer.part.four"/>
                </p>
                <p>
                  <FormattedMessage id="disclaimer.part.five"/>
                </p>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    );
  }
}

export default Disclaimer;



// WEBPACK FOOTER //
// ./src/views/disclaimer.js